/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/whats_app/waba/creative_optimization_settings" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postWabaCreativeOptimizationSettingsCacheKeys } from "./constants";
import type {
  PostWabaCreativeOptimizationSettingsProps,
  PostWabaCreativeOptimizationSettingsResult,
  PostWabaCreativeOptimizationSettingsResultError,
} from "./types";

export const postWabaCreativeOptimizationSettings = reactQueryMutationAdapter(
  postWabaCreativeOptimizationSettingsCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostWabaCreativeOptimizationSettingsResultError>()(
    (props: PostWabaCreativeOptimizationSettingsProps): Promise<PostWabaCreativeOptimizationSettingsResult> => {
      const { appGroupId, messagingServiceId, ...body } = props;

      return fetch(
        `/engagement/${appGroupId}/whats_app/waba/creative_optimization_settings?messaging_service_id=${messagingServiceId}`,
        "POST",
        body,
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
